import { Injectable, signal, WritableSignal } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { SignalStore } from 'src/app/shared/functions/store.functions';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;


  private excludedUrls: string[] = [
    'api/v1/notifications',
    'api/v1/auth/refreshToken',
    'sentrynel-be/auth/user',
  ];
  private excludedUrlFlux: string = 'api/v1/flux/';
  constructor(
    private loaderService: LoaderService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (this.excludedUrls.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    this.totalRequests++;
    this.loaderService.setLoading(true);

    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.loaderService.setLoading(false);
        }
      })
    );
  }
}

